import { render, staticRenderFns } from "./bannerReduis.vue?vue&type=template&id=112b4542&scoped=true"
import script from "./bannerReduis.vue?vue&type=script&lang=js"
export * from "./bannerReduis.vue?vue&type=script&lang=js"
import style0 from "./bannerReduis.vue?vue&type=style&index=0&id=112b4542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b4542",
  null
  
)

export default component.exports